/**
 * @module ol/webgl/ContextEventType
 */
/**
 * @enum {string}
 */
export default {
    LOST: 'webglcontextlost',
    RESTORED: 'webglcontextrestored',
};
//# sourceMappingURL=ContextEventType.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ol/webgl/ContextEventType.js
// module id = 1686
// module chunks = 8